import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ROUTE_URLS } from '@app/app.routes.names';

@Component({
  selector: 'app-quick-success',
  templateUrl: './quick-success.component.html',
  styleUrls: ['../quick-top-up.component.scss']
})

export class QuickSuccessComponent {
  public phoneNumber;

  constructor(
    public router: Router,
    private route: ActivatedRoute) {

    this.route.params.subscribe(params => {
      this.phoneNumber = params.mdn;
      this.phoneNumber = this.phoneNumber?.replace(/^(\d{0,3})(\d{0,3})(.*)/, '($1) $2-$3');
    });
  }

  public done(): void {
    this.router.navigate([`${ROUTE_URLS.HOME}`]);
  }
}
